import React from 'react'
import MemberFilter from './MemberFilter'
import { getContributorsApi} from '../../services/apiService'
import { showApiError } from '../utilities'
import { Table , Button} from 'antd';
import { CSVLink } from 'react-csv'
import GenmemberListPDF from './GenMemberListPDF'

class RptMemberList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataSource: [],
      loaded: false,
      PDFReady: false
    }
  }

  handleOnSumbit = (e) => {
    e.preventDefault();
    let search = e.target.elements[0].value
    let qString = "?filter=" + search + "&page=" + 1 + "&size=" + 9999
    this.loadData(qString)
  }

  loadData(qString) {
    getContributorsApi(qString)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          let contributors = json.contributors
          this.setState({
            dataSource: contributors, loaded: true
          })
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }


  finishDownloadPDF= () => {
    this.setState( {PDFReady: false} )
  }
  
  setPDFReady = () => {
    this.setState( {PDFReady: true} )
  }

  render() {

    let contributors = this.state.dataSource
    let source = contributors.map(
      x => {
        let address = x.address + ' ' + x.suburb
        return Object.assign({}, { offeringNo: x.offeringNo, displayName: x.displayName }, { address })
      }
    )

    let columns = [
      {
        title: 'Offering No',
        dataIndex: 'offeringNo',
        key: 'offeringNo',
      },
      {
        title: 'Display Name',
        dataIndex: 'displayName',
        key: 'displayName'
      },
      {
        title: 'Address',
        dataIndex: 'address',
        key: 'address'
      },

    ]


    function ShowTable(props) {
      if (props.dataSource.length > 0) {
        return (       
        <div>
          <div className='buttonsbar'>
          <CSVLink data={props.dataSource} filename='memberlist.csv' >
          <Button icon='file-excel'>Download CSV</Button> </CSVLink>
          <Button icon='file-pdf' 
            onClick={props.setPDFReady}>Download PDF</Button> 
          <GenmemberListPDF data={props.dataSource}
          ready={props.ready} doFinish={props.doFinish}
          /> 
        </div> 
          <Table columns={props.columns} 
              dataSource={props.dataSource} 
              rowKey='offeringNo'
          size="small" pagination={false} />
          </div>    
        )
    
      }
      return null
    }
    

    //console.log("RptMemberList.render()")
    return (
      <div className="content">
        <h2>{this.props.title}</h2>
        <MemberFilter sumbitFilter={this.handleOnSumbit} />
        <ShowTable columns={columns} dataSource={source} setPDFReady={this.setPDFReady}
        doFinish={this.finishDownloadPDF} ready={this.state.PDFReady}/>
      </div>
      )
  }
}



export default RptMemberList;